import { combineReducers } from "redux";
import {
  RECEIVE_POSTCODE_SUCCESS,
  RESET_POSTCODE,
} from "../../../common/constants/action-constants";

const initialState = [];

const postcodeAddress = (state = initialState, action) => {

  switch (action.type) {
    case RECEIVE_POSTCODE_SUCCESS:{
       return action.result;
    }
    case RESET_POSTCODE:
      return [];
    default:
      return state;
  }
};

const postcode = combineReducers({
   postcodeAddress: postcodeAddress,
});

export default postcode;